import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:\\xinyongban\\xinyidai-frontend\\node_modules\\@babel\\runtime-corejs2/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { superviseLogin, Register, getRoleInfo as _getRoleInfo, getBankInfo as _getBankInfo, zxBankLogin, getfinBankInfo as _getfinBankInfo } from "@/api/login";
import currentEnv from "../utils/envSetting";
import { getSmsSend } from "@/api/login";
export default {
  name: "login",
  data: function data() {
    var _this = this;

    var checkPhone = function checkPhone(rule, value, callback) {
      if (!value) {
        return callback(new Error("手机号不能为空"));
      } else {
        var reg = /^1[3|4|5|7|8][0-9]\d{8}$/;

        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("请输入正确的手机号"));
        }
      }
    };

    var validPassword = function validPassword(rule, value, callback) {
      var reg = /^(?=.*[0-9].*)(?=.*[A-Z].*)(?=.*[a-z].*).{6,20}$/;

      if (!reg.test(value)) {
        _this.spanStatus = false;
        callback(new Error("密码必须是由6-16位字母+数字组合"));
      } else {
        _this.spanStatus = true;
        callback();
      }
    };

    var secondPassword = function secondPassword(rule, value, callback) {
      if (_this.registereFrom.password == "") {
        callback(new Error("请先输入密码"));
      } else if (_this.registereFrom.password !== "") {
        if (_this.registereFrom.password == value) {
          callback();
        } else if (value == "") {
          callback(new Error("请输入确认密码"));
        } else if (_this.registereFrom.password !== value) {
          callback(new Error("两次密码不一致"));
        }
      }
    };

    return {
      spanStatus: true,
      options: [{
        value: "1",
        label: "企业用户" // {
        //   value: "2",
        //   label: "金融机构"
        // }, //互联网用1 ,2
        // {
        //   value: "3",
        //   label: "审核人"
        // },
        // {
        //   value: "4",
        //   label: "监管机构"
        // },
        // {
        //   value: "5",
        //   label: "银行授权书"
        // },
        // {
        //   value: "6",
        //   label: "信用中心"
        // }
        //政务外网 把options里的1,2注释
        //互联网   把把options里的的3,4注释

      }],
      value: "1",
      //政务外网 改为3 互联网为1
      activeIndex: "/xyd/home",
      loginForm: {
        loginName: "",
        password: "",
        phoneCode: "",
        //验证码
        sourceType: "1" //政务外网 改为3 互联网为1

      },
      loading: false,
      // 验证码倒计时相关
      countdown: 60,
      isCounting: false,
      pwdType: "password",
      loginUrl: "",
      registere: false,
      loginDialog: true,
      registereFrom: {
        name: "",
        sourceType: 1,
        mobilePhone: "",
        password: "",
        secondPassword: "",
        deptId: "",
        organization: ""
      },
      registereType: [{
        value: "1",
        label: "审核人" // {
        //   value: "2",
        //   label: "监管机构"
        // }

      }],
      finbankList: [],
      typeList: [],
      bankList: [],
      rules: {
        name: [{
          required: true,
          message: "请输入用户姓名",
          trigger: "blur"
        }, {
          min: 1,
          max: 20,
          message: "长度在1到4个字",
          trigger: "blur"
        }],
        sourceType: [{
          required: true,
          message: "请选择用户类型",
          trigger: "change"
        }],
        mobilePhone: [{
          validator: checkPhone,
          trigger: "blur"
        }],
        password: [{
          validator: validPassword,
          trigger: "blur"
        }],
        secondPassword: [{
          validator: secondPassword,
          trigger: "blur"
        }],
        deptId: [{
          required: true,
          message: "请选择区县",
          trigger: "change"
        }],
        organization: [{
          required: true,
          message: "请选择所属银行",
          trigger: "change"
        }]
      }
    };
  },
  created: function created() {
    var _this2 = this;

    // if (location.href.indexOf("#reloaded") == -1) {
    // location.href = location.href + "#reloaded";
    // location.reload();
    try {
      var params = this.$route.query.params;

      if (params != undefined) {
        // 直接跳转首页
        var res = zxBankLogin({
          params: params
        });
        Promise.resolve(res).then(function (result) {
          //处理返回的Promise
          if (result.data.code == 200) {
            sessionStorage.setItem("loginTime", result.data.data.userWebVo.loginTime);

            _this2.$store.commit("organization", result.data.data.userWebVo.organization);

            _this2.loading = false;
            sessionStorage.setItem("token", result.data.data.token);
            sessionStorage.setItem("phone", result.data.data.userWebVo.mobilePhone);
            sessionStorage.setItem("deptId", result.data.data.userWebVo.deptId);

            _this2.$store.commit("setSourceType", result.data.data.userWebVo.sourceType);

            _this2.$store.commit("setUserName", result.data.data.userWebVo.name);

            sessionStorage.setItem("currentTab", "AuthManagementSearch");

            _this2.$router.push("/xyd/my_center");

            _this2.$emit("myChange");
          } else {
            _this2.$message.error(result.msg);
          }
        });
      }
    } catch (_unused) {} // }


    this.getRoleInfo();
    this.getcurrentEnv();
  },
  methods: {
    handleGetCode: function handleGetCode() {
      var _this3 = this;

      //获取验证码
      if (this.isCounting) return; // 验证手机号

      if (!this.loginForm.loginName) {
        this.$message.warning('请先输入手机号');
        return;
      }

      var reg = /^1[3|4|5|7|8][0-9]\d{8}$/;

      if (!reg.test(this.loginForm.loginName)) {
        this.$message.warning('请输入正确的手机号');
        return;
      } // 开始倒计时


      this.isCounting = true;
      this.countdown = 60; // 模拟获取验证码请求

      getSmsSend({
        phone: this.loginForm.loginName,
        type: 1
      }).then(function (res) {
        if (res.data.code == 200) {
          _this3.$message.success('验证码已发送');
        } else {
          _this3.$message.error(res.msg);
        }
      });
      var timer = setInterval(function () {
        _this3.countdown--;

        if (_this3.countdown <= 0) {
          clearInterval(timer);
          _this3.isCounting = false;
          _this3.countdown = 60;
        }
      }, 1000);
    },
    // 当前环境
    getcurrentEnv: function getcurrentEnv() {
      switch (currentEnv) {
        case 1:
          this.options = [{
            value: "1",
            label: "企业用户"
          }];
          this.value = "1";
          this.loginForm.sourceType = "1";
          break;

        case 2:
          this.options = [{
            value: "1",
            label: "企业用户" //调登录注册苏商通

          }];
          this.value = "1";
          this.loginForm.sourceType = "1";
          break;

        case 3:
          this.options = [{
            value: "3",
            label: "审核人"
          }, {
            value: "4",
            label: "监管机构"
          }];
          this.value = "3";
          this.loginForm.sourceType = "3";
          break;

        default:
          break;
      }
    },
    getRoleInfo: function getRoleInfo() {
      var _this4 = this;

      var params = {
        parent: 4
      };

      _getRoleInfo(this.sendParam(params)).then(function (res) {
        res = _this4.paramDecrypt(res);

        if (res.code == 200) {
          _this4.typeList = res.data;
        }
      }).catch(function (error) {});
    },
    // 给deptId赋值
    changeBlank: function changeBlank(valCode) {
      // 根据选中的 bank_code 查找对应的银行对象
      var selectedBank = this.finbankList.find(function (item) {
        return item.bank_code === valCode;
      });

      if (selectedBank) {
        this.registereFrom.deptId = selectedBank.bank_id;
      }
    },
    //获取金融机构银行
    getfinBankInfo: function () {
      var _getfinBankInfo2 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _getfinBankInfo();

              case 2:
                res = _context.sent;
                this.finbankList = res.data.data;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getfinBankInfo() {
        return _getfinBankInfo2.apply(this, arguments);
      }

      return getfinBankInfo;
    }(),
    // 获取银行
    getBankInfo: function () {
      var _getBankInfo2 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _getBankInfo();

              case 2:
                res = _context2.sent;
                this.bankList = res.data.data;
                this.finbankList = res.data.data;

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getBankInfo() {
        return _getBankInfo2.apply(this, arguments);
      }

      return getBankInfo;
    }(),
    // 用户注册的选项
    seleChange: function seleChange(val) {
      if (val == 2) {
        this.registereFrom.organization = "";
        this.getBankInfo();
      } else if (val == 5) {
        this.registereFrom.organization = "";
        this.getBankInfo();
      }
    },
    submitForm: function submitForm(formName) {
      var _this5 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          Register(_this5.sendParam(_this5.registereFrom)).then(function (res) {
            res = _this5.paramDecrypt(res);

            if (res.code == 200) {
              _this5.$message.success(res.msg);

              _this5.registere = false;
              _this5.loginDialog = true;
            } else if (res.code == 202) {
              _this5.$message.error(res.msg);
            } else {
              _this5.$message.error(res.msg);
            }
          });
        } else {
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    //审核人监管机构注册
    registered: function registered() {
      this.loginDialog = false;
      this.registere = true;
    },
    cli_choose: function cli_choose(e) {
      this.loginForm.sourceType = e;
    },
    goPath: function goPath(path) {
      this.$router.push(path);
    },
    handleLogin: function handleLogin() {
      var _this6 = this;

      this.$refs.loginForm.validate(function (valid) {
        if (valid) {
          _this6.loading = true;
          var param = {
            loginName: _this6.loginForm.loginName,
            password: _this6.loginForm.password,
            sourceType: _this6.loginForm.sourceType,
            phoneCode: _this6.loginForm.phoneCode
          };

          var body = _this6.sendParam(param);

          var res = superviseLogin(body);
          Promise.resolve(res).then(function (value) {
            //处理返回的Promise
            var result = _this6.paramDecrypt(value);

            if (result.code == 200) {
              sessionStorage.setItem("loginTime", result.data.userWebVo.loginTime); // sessionStorage.setItem(
              //   "organization",
              //   result.data.userWebVo.organization
              // );

              _this6.$store.commit("organization", result.data.userWebVo.organization);

              _this6.loading = false;
              sessionStorage.setItem("token", result.data.token);
              sessionStorage.setItem("phone", result.data.userWebVo.mobilePhone);
              sessionStorage.setItem("deptId", result.data.userWebVo.deptId);

              _this6.$store.commit("setSourceType", result.data.userWebVo.sourceType);

              if (result.data.userWebVo.sourceType == "2" || result.data.userWebVo.sourceType == "5") {
                sessionStorage.setItem("currentTab", "AuthManagementSearch"); //设置2 5 角色 个人中心是信用数据查询页面
              }

              _this6.$store.commit("setUserName", result.data.userWebVo.name);

              _this6.$router.push({
                path: "/xyd/index"
              });

              _this6.$emit("myChange");
            } else {
              _this6.$message.error(result.msg);
            }
          });
        } else {
          return false;
        }
      });
    },
    userlogin: function userlogin() {
      //========================================================================================================
      if (currentEnv == 1) {
        // 测试环境用这个
        this.$router.push({
          name: "xydindex",
          // path: '/xyd/index',
          query: {
            code: this.loginForm.sourceType === "2" ? "jinrongjigou" : undefined
          },
          params: {
            status: true
          }
        });
      } else {
        // ========================================================================================================
        // let paramurl = "http://2.46.5.101:8084/#/xyd/index"; //测试环境
        //
        // let paramurl = "https://credit.suzhou.com.cn/#/xyd/index"; //生产正式环境
        // a132e77e-b76a-4b4e-a85c-e20384e0d45c
        var paramurl = "https://credit.suzhou.com.cn/#/xyd/index";
        var encodedParam = encodeURIComponent(paramurl);
        var url = "https://sst.suzhou.gov.cn/sst-smartcity-sso/frame/pages/login/memlogin?response_type=code&redirect_uri=".concat(encodedParam, "&client_id=44d6f0c6-1559-41aa-9cc2-a4a684399606  ");
        window.open(url, "_self");
      }
    }
  }
};